export enum OpticOddsFixtureStatus {
	Unplayed = 'unplayed',
	Live = 'live',
	Half = 'half',
	Completed = 'completed',
	Cancelled = 'cancelled',
	Suspended = 'suspended',
	Delayed = 'delayed',
}
